import React, { useState, useEffect, useRef } from "react";
import doctor from "../images/doctor-2.png";
import Avtar from "../images/profile.svg";
import { BsCameraVideo } from "react-icons/bs";
import axios from "axios";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import AppointmentDetailModal from "../Appointments/AppointmentDetailModal";
import AppointmentDetailPopup from "./AppointmentDetailPopup";
import { FiPhone } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import '../ScrollBar/ScrollBar.css'
interface PatientProfileProps {
  patientId: number | null;
  onClose: () => void;
}

const PatientProfilePopup: React.FC<PatientProfileProps>=({
  patientId,
  onClose,
})=>{
  const [profileImage, setProfileImage] = useState("");
  const [patientProfile, setPatientProfile] = useState<any>([]);
  const [doctorAppointments, setdoctorAppointments] = useState<any>([]);
  const [age, setAge] = useState<number | null>(null);
  const [activeTab, setActiveTab] = useState("Chronic Condition");
  const [activePrescriptionButton, setPrescriptionButton] = useState<"medication"|"remark"|null>("medication");
  const [appointmentPopup, setAppointmentPopup] = useState<boolean>(false);
  const [selectedAppointment, setSelectedAppointment] = useState<any | null>(null);
  const [selectedDoctorInfo, setSelectedDoctorInfo] = useState<any | null>(null);
  const [isLoading , setLoading] = useState<boolean>(false);
  const [selectedPatientInfo, setSelectedPatientInfo] = useState<any | null>(null);
const [followUpDate, setFollowUpDate] = useState<string>("");
  
  const token =sessionStorage.getItem("token");
  const sliderRef = useRef<HTMLDivElement>(null);


const fetchAppointments = async () => {
  setLoading(true)
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/Patient/doctorappointments`, {
      params: {
        patientId: patientId
      }
    });
    const sortedAppointments = response.data.sort((a: any, b: any) => {
  const dateTimeA = new Date(`${a.appointmentDate}T${a.slotStartTime}`);
  const dateTimeB = new Date(`${b.appointmentDate}T${b.slotStartTime}`);
  return dateTimeB.getTime() - dateTimeA.getTime();
});
// setDoctorAppointments(sortedAppointments);
    setdoctorAppointments(sortedAppointments)
  } catch (error) {
    console.error('Error fetching appointments:', error);
  }finally{
 setLoading(false)
  }
}; 

useEffect(()=>{
  fetchAppointments()
},[])

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft-=260;
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
    sliderRef.current.scrollLeft+=260;
    }
  };

  useEffect(() => {
    const fetchPatientProfile = async (patientId: any) => {
      try {
        const response: any = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorforpatientprofiledetails?patientId=${patientId}`,{
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
    );
        setProfileImage(response.data?.patientImages[0]?.imagePath)
        setPatientProfile(response.data);
        if (response.data.dob){
          const birthDate = new Date(response.data.dob);
          const today = new Date();
          const age =
            today.getFullYear()-
            birthDate.getFullYear()-
            (today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() &&
              today.getDate() < birthDate.getDate())
              ? 1
              : 0);
          setAge(age);
        }
      } catch (error: any) {
        console.error("error in Geting PatientProfie");
      }
    };
    fetchPatientProfile(patientId);
  }, [patientId]);

  const handlePatientPrescription = (appointment:any,doctor:any,patientProfile:any,followUpDate:any) => {
    setAppointmentPopup(true);
    setFollowUpDate(followUpDate)
    setSelectedAppointment(appointment)
      setSelectedDoctorInfo(doctor);
            setSelectedPatientInfo(patientProfile);


  };
  const handleCloseAppointmentPopup = () => {
    setAppointmentPopup(false);
  };
  return (
    <div>
 {appointmentPopup && selectedAppointment && (

      <AppointmentDetailPopup
        appointmentId={selectedAppointment}
        onClose={handleCloseAppointmentPopup}
        doctorInfo={selectedDoctorInfo}
        patientInfo={selectedPatientInfo}
        
        followUpDate={followUpDate}
        
      />
  
)}

      <div className="fixed inset-0 bg-black bg-opacity-20 flex justify-center items-center z-30" 
         onClick={onClose}>
        <div className="bg-[#F0F7FF] rounded-lg shadow-lg p-2 xs:p-6 w-full  w-[100%] sm:w-[90%] md:w-[80] lg:w-[65%] relative" 
            onClick={(e) => e.stopPropagation()}>
           <button
            onClick={onClose}
            className="absolute top-2 right-2 text-gray-600 hover:text-black"
          >
            ✖
          </button>
          <p className="text-center text-[18px] font-semibold pb-5 ">
            Patient Summary
          </p>
          <div className="bg-white px-2 xs:px-6 py-5 rounded-lg ">





<div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-1 pb-4 md:pb-5  rounded-xl border-b-2">
  <div className="flex items-center gap-3 md:gap-4 justify-center md:justify-start col-span-1 md:col-span-1">
    {profileImage ? (
      <img
        src={`${process.env.REACT_APP_BASE_URL}${profileImage}`}
        alt="Patient"
        className="w-16 h-16 rounded-full object-cover border-2 border-gray-200 shadow-sm flex-shrink-0"
      />
    ) : (
      <img
        src={Avtar}
        alt="Patient"
        className="w-16 h-16 rounded-full object-cover border-2 border-gray-200 shadow-sm flex-shrink-0"
      />
    )}

    <div className="flex-1 min-w-0">
      <p className="text-[14px] md:text-[16px] font-semibold text-gray-800 leading-tight truncate">
        {patientProfile?.patientName}
      </p>
      <div className="flex items-center gap-2 mt-1 text-[11px] md:text-[12px] text-gray-600">
        <span>{age} Years</span>
        <span className="text-gray-400">•</span>
        <span>{patientProfile?.gender === "M" ? "Male" : "Female"}</span>
      </div>
    </div>
  </div>

  <div className="block md:hidden col-span-1">
    <div className="flex items-center justify-around bg-gray-50 rounded-lg  md:p-3">
      {/* Blood Group */}
      <div className="text-center">
        <p className="text-gray-500 text-[10px] font-medium mb-1">Blood Group</p>
        <span className="text-red-500 text-[14px] font-bold">
          {patientProfile?.bloodGroup || "-"}
        </span>
      </div>

      {/* Patient ID */}
      <div className="text-center">
        <p className="text-gray-500 text-[10px] font-medium mb-1">Patient ID</p>
        <span className="text-[#00AC7D] text-[11px] font-bold">
          {patientProfile?.patientId || "N/A"}
        </span>
      </div>

      {/* Phone */}
      <div className="text-center">
        <p className="text-gray-500 text-[10px] font-medium mb-1">Phone</p>
        {patientProfile?.phoneNo ? (
          <a
            href={`tel:${patientProfile.phoneNo}`}
            className="p-2 bg-blue-50 text-[#184A84] hover:bg-blue-100 rounded-full transition-all inline-block"
            title={`Call ${patientProfile.phoneNo}`}
          >
            <FiPhone className="w-4 h-4" />
          </a>
        ) : (
          <span className="text-gray-400 text-[12px]">-</span>
        )}
      </div>
    </div>
  </div>

  {/* Desktop: Patient ID (Middle) */}
  <div className="hidden md:flex flex-col items-center justify-center">
    <p className="text-gray-500 text-xs font-medium mb-1">Patient ID</p>
    <div className="px-3 py-1 bg-gradient-to-r from-emerald-50 to-green-50 rounded-lg border border-green-200 shadow-sm">
      <p className="text-xs font-bold text-[#00AC7D]">
        {patientProfile?.patientId || "N/A"}
      </p>
    </div>
  </div>

  {/* Desktop: Blood Group & Contact (Right Side) */}
  <div className="hidden md:grid grid-cols-2 gap-6 items-center">
    {/* Blood Group */}
    <div className="text-center">
      <p className="text-gray-500 text-[12px] font-medium mb-1">Blood Group</p>
      <span className="text-red-500 text-[13px] font-semibold tracking-wide">
        {patientProfile?.bloodGroup || "-"}
      </span>
    </div>

    {/* Phone */}
    <div className="text-center">
      <p className="text-gray-500 text-[12px] font-medium mb-1">Phone</p>
      {patientProfile?.phoneNo ? (
        <div className="flex items-center justify-center gap-2">
            <a
            href={`tel:${patientProfile.phoneNo}`}
            className="p-1.5 bg-blue-50 text-[#184A84] hover:bg-blue-100 hover:text-[#009A85] transition-all rounded-full shadow-sm"
            title="Call Patient"
          >
            <FiPhone className="w-3 h-3"/>
          </a>
           <span className="text-[13px] text-gray-700 font-medium">
            {patientProfile.phoneNo}
          </span>
       
        </div>
      ) : (
        <p className="text-[13px] font-semibold text-gray-400">-</p>
      )}
    </div>
  </div>
</div>







            {/* Medical Information of the patient  */}
            <div>
              {/* Toggle Buttons */}
              <div className="flex justify-between ">
                  <div className="flex gap-3 mt-5 mb-5">
                <button
                  onClick={() => setActiveTab("Chronic Condition")}
                  className={`px-4 py-1 rounded-full transition-all ${
                    activeTab === "Chronic Condition"
                      ? "bg-[#009A85] text-white"
                      : "border border-gray-500 text-gray-500"
                  }`}
                >
                  Chronic Condition
                </button>
                <button
                  onClick={() => setActiveTab("Allergies")}
                  className={`px-4 py-1 rounded-full transition-all ${
                    activeTab === "Allergies"
                      ? "bg-[#009A85] text-white"
                      : "border border-gray-500 text-gray-500"
                  }`}
                >
                  Allergies
                </button>
              </div>

             
              </div>
              {/* Conditional Data */}
              {activeTab === "Chronic Condition" && (
  <p className="text-[12px] text-gray-700">
    {patientProfile.chronicCondition?.trim()
      ? patientProfile.chronicCondition
      : "There is no chronic condition."}
  </p>
)}
{activeTab === "Allergies" && (
  <p className="text-[12px] text-gray-700">
    {patientProfile.allergies?.trim()
      ? patientProfile.allergies
      : "There are no allergies."}
  </p>
)}
            </div>
          </div>

          <div className=" mt-5">
            <p className="text-[16px] font-semibold">
              Completed Appointments
            </p>
            <p className="text-[12px] text-[#606060]">
    Stay updated with Patient’s latest <strong>completed</strong> appointments and follow-ups.
  </p>
            <div className="relative mt-5">

              <button
                onClick={scrollLeft}
                className="absolute -left-4 top-1/2 -translate-y-1/2 bg-white shadow-md p-1 rounded-full z-10"
              >
              <FaChevronLeft className="text-sm text-[#009A85]" />
              </button>


           <div
  ref={sliderRef}
  className={`flex gap-3 ${doctorAppointments.length > 0 ? "overflow-x-scroll custom-scrollbar" : ""} no-scrollbar`}
  style={{ scrollBehavior: "smooth" }}
>
   {isLoading?(
    <div className="relative w-full h-[60px] flex justify-center items-center py-10">
      <div className="absolute top-2/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 loader"></div>
    </div>
  ) : doctorAppointments.length === 0 ? (
    <div className="text-gray-600 text-sm p-4">
      There are no previous appointments.
    </div>
  ) : (
    doctorAppointments.map((doctor: any) => (
      <div
        key={doctor.id}
        onClick={() => handlePatientPrescription(doctor.appoitmentId
, doctor,patientProfile,doctor.followUpDate)}
        className="min-w-[250px] flex justify-between items-center bg-[#D4EDFF] p-3 rounded-lg shadow-md border border-[#A3D8FF] cursor-pointer"
      >
        <div>
          <p className="text-[14px] font-semibold text-gray-800">
            {doctor.doctorName}
          </p>
          <p className="text-[10px] text-gray-600">
            {doctor.specializationName}
          </p>
          <p className="text-[12px] font-semibold mt-2">
            {doctor.appointmentDate}
          </p>
        </div>
        <div className="flex flex-col items-center">
          <div className="bg-[#184A84] p-[5px] rounded-full shadow-md flex justify-center">
            <BsCameraVideo className="text-white text-xs" />
          </div>
          <p className="text-[12px] font-semibold text-[#184A84] mt-5">
            {doctor.slotStartTime}
          </p>
        </div>
      </div>
    ))
  )}
</div>
              <button
                onClick={scrollRight}
                className="absolute -right-4 top-1/2 -translate-y-1/2 bg-white shadow-md p-1 rounded-full z-10"
              >
                <FaChevronRight className="text-sm text-[#009A85]" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* {appointmentPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50" onClick={handleCloseAppointmentPopup}>
          <div className="bg-white p-6 rounded-lg shadow-lg w-full xs:w-[70%] sm:w-[50%] lg:w-[40%]  relative" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={handleCloseAppointmentPopup}
              className="absolute right-1 top-1   text-gray-600 p-1 rounded hover:text-black"
            >
              ✖
            </button>

            <div className="text-center text-[18px] font-semibold border-b-2  py-3">
              Prescription
            </div>
            <div className="flex gap-3 mt-5">

              <button
                className={` p-1 px-4 rounded-full  ${activePrescriptionButton==="medication"? "bg-[#009A85] text-white"  : "border border-gray-500 text-gray-500"  }`}
                onClick={() => setPrescriptionButton("medication")}
              >
                Medications
              </button>
              <button
              className={` p-1 px-4 rounded-full ${activePrescriptionButton==="remark"?  "bg-[#009A85] text-white"  : "border border-gray-500 text-gray-500" }`}
              onClick={() => setPrescriptionButton("remark")}>
                Remarks
              </button>
            </div>

            {activePrescriptionButton === "medication" && (
              <div className="bg-[#F2F2F2] rounded-lg p-5 mt-5">
                {medications.map((item)=>(
                  <div className="flex gap-2">
                    <div className="text-sm truncate ">{item.type}-</div>
                    <div className="text-sm text-gray-700 ">{item.name}</div>
                  </div>
                ))}
              </div>
            )}
            {activePrescriptionButton === "remark" && (
              <div className="bg-[#F2F2F2] rounded-lg p-5 mt-5">
                <p className="text-gray-700 text-sm italic">
                  Patient was diagnosed with Headache , give medications. 
                  Has serious problem of migraine. Not in good situation.
                </p>
              </div>
            )}
          </div>
        </div>
      )} */}
    </div>
  );
};
export default PatientProfilePopup;
